import { Question } from "interfaces/question";
export const interviewGloria: Question[] = [
  {
    id: 1,
    title:
      "Se você pudesse gravar um feat. em alguma música da RuPaul, qual você escolheria para dar uns gritos em cima?",
    answer:
      "Queria muito dar uns gritos em cima de “Jealous of my boogie”, do álbum Champion, vulgo minha all-time-fav da Ru. Amo ver a mamãe nessa vibe setentista!",
  },
  {
    id: 2,
    title:
      "Na sua opinião, quais são as vozes mais potentes do pop atualmente?",
    answer: "Ariana Grande e Priscilla Alcântara.",
  },
  {
    id: 3,
    title:
      "Se tivesse que resumir o seu som combinando só discos que já existem de outros artistas, quais você colocaria no caldeirão Gloria Groove?",
    answer:
      "No meu caldeirão tem um Identidade (2003), de Sandy & Júnior, um Confessions (2004), do Usher, um Born this way (2011), da Lady Gaga, um Frank (2003), da Amy Winehouse, um B’Day (2006), da Beyoncé, e um Pink friday (2010), da Nicki Minaj.",
  },
  {
    id: 4,
    title:
      "Você tem trabalhos muito legais de dublagem. Se pudesse dublar qualquer personagem em desenho animado, qual escolheria?    ",
    answer:
      "Eu adoraria ser a voz de algum side kick cômico da Disney, tipo o Mushu ou a Dory.",
  },
  {
    id: 5,
    title: "Cinco músicas para mexer o bumbum de ouro?",
    answer:
      "Dance (A$$) Remix, Big Sean e Nicki Minaj. Vai malandra, Anitta, Mc Zaac. Maejor, Tropkillaz e DJ Yuri Martins. Bum bum tam tam, MC Fioti. Tabacada boa (Ela é safadinha), MC Tchelinho, Leo Justi e Heavy Baile. Body, Megan Thee Stallion.",
  },
  {
    id: 6,
    title:
      "Se você fosse ter uma girl band com qualquer artista pop do Brasil, quem estaria nela?",
    answer:
      "Teria uma girl band bem vocal R&B com a IZA, a Ludmilla e a Priscilla Alcântara. Eu seria a rapper do grupo, óbvio.",
  },
  {
    id: 7,
    title: "Qual diva pop você mais ama no mundo e por quê?",
    answer:
      "Difícil de alguém bater o fascínio que eu sinto pela arte de Beyoncé. A mamãe é tudo na minha vida.",
  },
  {
    id: 8,
    title:
      "O que tem por trás da magia da música pop? Por que você acha que ela move e comove tanta gente?",
    answer:
      "Acredito que a música pop tem o poder de construir pontes entre lugares diferentes e estilos improváveis. É o campo onde as possibilidades musicais se expandem e os encontros se tornam possíveis.",
  },
  {
    id: 9,
    title:
      "Quais artistas que vieram antes de você foram fundamentais para você existir hoje e fazer sua música?",
    answer:
      "Todos os artistas da minha família, como minha mãe, minha tia, meus avós. Sem a influência deles, nada disso seria possível. Todos os músicos e profissionais brilhantes com quem dividi espaço e conhecimento enquanto cantor, backing vocal e dublador. Todas as drag queens que conheci em minha jornada como Gloria Groove, pois elas me mostraram o que é ter paixão e dedicação pela arte da performance. Todos os meus ídolos, que mesmo de longe me acompanharam e me mostraram que era possível encontrar meu caminho e mostrar meu talento, criatividade e autenticidade.",
  },
  {
    id: 10,
    title: "O que você espera para o futuro da música pop?",
    answer:
      "Espero por um pop cada vez mais livre, ilimitado, diverso e democrático. Tenho muita paixão pela construção do nosso pop nacional e pelo tanto que ele vem se destacando mundo afora. Que a nossa voz e o nosso idioma possam ser ouvidos em todo o planeta, pois talento e disposição pra isso o Brasil tem de sobra!",
  },
];
